import styles from "./Filter.module.css"
import { useState, useEffect } from 'react';
import SubmitButton from "../../components/Button/SubmitButton/SubmitButton";
import {X} from 'lucide-react';
import FilterMenu from "../../components/Filter/components/FilterMenu/FilterMenu";
import { filterOverlayProps } from "../../types/tag";
import { getTags } from "../../constants/tags";
import FilterPrice from "./components/FilterPrice/FilterPrice";
import { useFilterContext } from "../../context/FilterContext";
import { FilterDataProps } from "../../types/filter.types";
import { useTranslation } from "react-i18next";
import { handleBackgroundScroll } from "../../utils/backgroundScroll";
import { defaultFiltersSmall } from "../../constants/filters";
import { log } from "../../utils/logger";
/**
* A filter overlay.
*
* @param props Filter props
* @param {() => void} props.setOpen - Handler for changing filter overlay open state
* @param {boolean} props.open - Whether the filter overlay is open
* @returns TSX.Element
*/
const Filter = ({open, setOpen} : filterOverlayProps) => {
    const { t } = useTranslation(); // Translation
    const tags = getTags(t); // Tags
    const { filterData, setAllFilters, basicFilter } = useFilterContext(); // Filter data
    // Data for price range input
    const range = filterData.cena ?? [0, 100000]
    const minPrice = range[0];
    const maxPrice = range[1];
    const [priceRange, setPriceRange] = useState({ minPrice: minPrice, maxPrice: maxPrice })
    const [filters, setFilters] = useState<Record<keyof FilterDataProps, string[]>>(defaultFiltersSmall)
    // Set new filter
    const changeFilters = (key: keyof FilterDataProps, filters: string[]) => {
        setFilters((prev) => {
            const updated = { ...prev, [key]: filters };
            return updated;
        });
    } 
    // Stop scroll on open
    useEffect(()=>{
        handleBackgroundScroll(open)
        setPriceRange({minPrice: minPrice, maxPrice: maxPrice})
    }, [open])

    // Handle submitting filters
    const submitFilters = () => {
        // Create a copy of current filter data to build upon
        const updatedFilterData = { ...filterData };
        
        // Go through all the categories
        Object.entries(filters).forEach(([key, value]) => {
            const newFilters: Record<string, boolean> = {};
            // Find the desired category
            const category = tags.find(cat => cat.slug === key)
            // Go through all the tags for given category and check if they are selected
            category?.tags.forEach(tag => {
                newFilters[tag.slug] = value.includes(tag.slug);
            });
            // Update the filter data copy instead of calling handleFilter
            if (key !== "cena") {
                updatedFilterData[key as keyof FilterDataProps] = newFilters as any;
            }
        });
        
        // Set the price range
        if ((filterData.cena && priceRange.minPrice !== filterData.cena[0]) || 
            (filterData.cena && priceRange.maxPrice !== filterData.cena[1])) {
            updatedFilterData.cena = [priceRange.minPrice, priceRange.maxPrice];
        }
        
        // Apply all filter changes at once using setAllFilters
        setAllFilters(updatedFilterData);
    }



    return(
        <>
            <div className={styles.FilterWrapper} style={open == false ? { display: "none" } : undefined}>
                <div className={styles.FilterBlur} onClick={setOpen}></div>
                <div className={styles.FilterDrawer}>
                    <p className={styles.FilterDrawerTitle}>{t("filter.title")}</p>
                    <div className={styles.FilterDrawerContent}>
                        {basicFilter !== "storage" && 

                        tags.map((tag, index)=>(
                            <FilterMenu
                                key={tag.title}
                                title={tag.title}
                                slug={tag.slug}
                                tags={tag.tags}
                                setFilters={changeFilters}
                                filterOpen={open}
                            />
                        ))
                        }
                        <FilterPrice
                        menuOpen={open}
                        min={0}
                        max={100000}
                        setPrice={(min: number, max: number) => setPriceRange({ minPrice: min, maxPrice: max })}
                        />
                    </div>
                    <div className={styles.FiilterDrawerConfirm}>
                        <SubmitButton text={t("buttons.confirm")} onClick={()=> {submitFilters(); setOpen()}}/>
                    </div>
                    <button className={styles.FilterDrawerClose} onClick={setOpen}>
                        <X/>
                    </button>
                </div>
            </div>
        </>
    )
};

export default Filter;